import { Inject, Injectable } from '@angular/core';
import { AES, algo, enc, lib, PBKDF2 } from 'crypto-js';

export interface EncryptionConfig {
  IV: string;
  passphrase: string;
  salt: string;
  keySize: number;
  iterationCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
   private _param1: string; //IV
  private _param2: string; //passphrase
  private _param3: string; //salt
  private _param4: number; //keySize
  private _param5: number; //iteration
 hasher = algo.SHA1;

  constructor() {
    this._param1 = '4d67fd8ee80132c6115e39880b08165d';
    this._param2 = 'tcs@1234';
    this._param3 = '2df6bf74cb133595';
    this._param4 = 128;
    this._param5 = 1000;
  }

  /**
   * Getter param1
   * @return {string }
   */
  public get param1(): string {
    return this._param1;
  }

  /**
   * Getter param2
   * @return {string }
   */
  public get param2(): string {
    return this._param2;
  }

  /**
   * Getter param3
   * @return {string }
   */
  public get param3(): string {
    return this._param3;
  }

  /**
   * Getter param4
   * @return {number}
   */
  public get param4(): number {
    return this._param4;
  }

  /**
   * Getter param5
   * @return {number}
   */
  public get param5(): number {
    return this._param5;
  }

  encrypt(
    plainText: string,
    salt?: string
  ): { cipherText: string; salt: string } {
    if (!salt) salt = this.generateSalt();

    let key = this.getKey(salt);

    let encrypted = AES.encrypt(plainText, key, {
      iv: enc.Hex.parse(this.param1),
    });

    return { cipherText: encrypted.ciphertext.toString(enc.Base64), salt };
  }

  decrypt(cipherText: string, salt?: string) {
    let key = this.getKey(salt);

    let cipherParams = lib.CipherParams.create({
      ciphertext: enc.Base64.parse(cipherText),
    });
    let decrypted = AES.decrypt(cipherParams, key, {
      iv: enc.Hex.parse(this.param1),
    });
    return decrypted.toString(enc.Utf8);
  }

  private getKey(salt) {
    return PBKDF2(this.param2, enc.Hex.parse(salt), {
      keySize: this.param4 / 32,
      iterations: this.param5,
      hasher: this.hasher,
    });
  }

  generateSalt() {
    return lib.WordArray.random(8)?.toString();
  }

  random() {
    let salt = lib.WordArray.random(128 / 8);
    return salt.toString();
  }
}
